"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VTabsMenu = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var Tabs = core_1.Tabs;
var VTabsMenu = (function (_super) {
    __extends(VTabsMenu, _super);
    function VTabsMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.handleNavbarTabChange = function (navbarTabId) {
            _this.setState({ navbarTabId: navbarTabId });
            _this.props.tabList.forEach(function (item) {
                if (item.navbarTabId === navbarTabId) {
                    _this.props.handleChange(item);
                }
            });
        };
        _this.state = {
            animate: _this.props.animate || false,
            navbarTabId: _this.props.tabList[0].navbarTabId || '',
            vertical: false
        };
        return _this;
    }
    VTabsMenu.prototype.render = function () {
        var options = __rest(this.props, []);
        return (react_1.default.createElement(style_1.TabsStyle, { color: options.color, indicatorActive: options.indicatorActive, hoverColor: options.hoverColor, active: options.active },
            react_1.default.createElement(Tabs, { animate: this.state.animate, id: "navbar", large: true, onChange: this.handleNavbarTabChange, selectedTabId: this.state.navbarTabId }, options.tabList.map(function (tab) {
                var label = tab.icon && (react_1.default.createElement(style_1.TabIcon, { key: tab.key },
                    react_1.default.createElement(core_1.Icon, { style: style_1.labelIcon, icon: tab.icon.icon, iconSize: tab.icon.iconSize && tab.icon.iconSize, color: tab.icon.color && tab.icon.color, intent: tab.icon.intent && tab.icon.intent }),
                    react_1.default.createElement("span", null, tab.label)));
                return (react_1.default.createElement(core_1.Tab, { key: tab.key, id: tab.navbarTabId, title: label || tab.label }));
            }))));
    };
    return VTabsMenu;
}(react_1.Component));
exports.VTabsMenu = VTabsMenu;
